var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2255(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1765.479,
    height: 328,
    viewBox: "0 0 1765.479 328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2255",
    "data-name": "Group 2255",
    transform: "translate(0)",
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11386",
    "data-name": "Path 11386",
    d: "M219.166,231.221h56.1a3.543,3.543,0,0,0,3.65-3.432V175.032a3.543,3.543,0,0,0-3.65-3.432H219.15a3.543,3.543,0,0,0-3.65,3.432v52.757A3.567,3.567,0,0,0,219.166,231.221Z",
    transform: "translate(125.292 -41.409)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9680",
    "data-name": "Path 9680",
    d: "M537.253,526.011h56.279a3.546,3.546,0,0,0,3.653-3.434V469.634a3.546,3.546,0,0,0-3.653-3.435H537.253a3.546,3.546,0,0,0-3.653,3.435v52.914A3.569,3.569,0,0,0,537.253,526.011Z",
    transform: "translate(572.672 -364.355)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11552",
    "data-name": "Path 11552",
    d: "M536.867,519.693H587.2a3.172,3.172,0,0,0,3.267-3.072V469.272A3.172,3.172,0,0,0,587.2,466.2H536.867a3.172,3.172,0,0,0-3.267,3.072V516.6A3.192,3.192,0,0,0,536.867,519.693Z",
    transform: "translate(28.284 -254.55)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11385",
    "data-name": "Path 11385",
    d: "M535.587,498.729h30.608a1.929,1.929,0,0,0,1.987-1.868V468.068a1.929,1.929,0,0,0-1.987-1.868H535.587a1.929,1.929,0,0,0-1.987,1.868v28.778A1.941,1.941,0,0,0,535.587,498.729Z",
    transform: "translate(-215.357 -282.822)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9681",
    "data-name": "Path 9681",
    d: "M1750.326,348.785h58.819a6.236,6.236,0,0,0,6.426-6.042v-55.3a6.236,6.236,0,0,0-6.426-6.042h-58.819a6.236,6.236,0,0,0-6.426,6.042v55.3A6.218,6.218,0,0,0,1750.326,348.785Z",
    transform: "translate(-1153.336 -107.533)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1572",
    "data-name": "Group 1572",
    transform: "translate(1564.928 129.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9684",
    "data-name": "Path 9684",
    d: "M232.026,1364.819c13.529,0,24.526-10.339,24.526-23.059s-11-23.059-24.526-23.059-24.526,10.339-24.526,23.059S218.5,1364.819,232.026,1364.819Zm0-34.911c6.944,0,12.606,5.323,12.606,11.852s-5.662,11.852-12.606,11.852-12.606-5.323-12.606-11.852S225.082,1329.908,232.026,1329.908Z",
    transform: "translate(-207.5 -1318.7)",
    fill: "#0267c1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2187",
    "data-name": "Group 2187",
    transform: "translate(154.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9684-2",
    "data-name": "Path 9684",
    d: "M238.237,1376.5c16.956,0,30.737-12.957,30.737-28.9s-13.781-28.9-30.737-28.9-30.737,12.957-30.737,28.9S221.281,1376.5,238.237,1376.5Zm0-43.752c8.7,0,15.8,6.672,15.8,14.853s-7.1,14.853-15.8,14.853-15.8-6.672-15.8-14.853S229.535,1332.745,238.237,1332.745Z",
    transform: "translate(-207.5 -1318.7)",
    fill: "#0267c1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    transform: "translate(1161.404 247.688)",
    fill: "none",
    stroke: "#53b1ff",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.376,
    cy: 19.157,
    rx: 20.376,
    ry: 19.157,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.376,
    cy: 19.157,
    rx: 15.376,
    ry: 14.157,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    transform: "translate(1724.728 260.035)",
    fill: "none",
    stroke: "#53b1ff",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.376,
    cy: 19.157,
    rx: 20.376,
    ry: 19.157,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.376,
    cy: 19.157,
    rx: 15.376,
    ry: 14.157,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    transform: "translate(104.275 289.686)",
    fill: "none",
    stroke: "#53b1ff",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.376,
    cy: 19.157,
    rx: 20.376,
    ry: 19.157,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.376,
    cy: 19.157,
    rx: 15.376,
    ry: 14.157,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_331",
    "data-name": "Ellipse 331",
    transform: "translate(0 113.441)",
    fill: "none",
    stroke: "#53b1ff",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.376,
    cy: 19.157,
    rx: 20.376,
    ry: 19.157,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.376,
    cy: 19.157,
    rx: 15.376,
    ry: 14.157,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_332",
    "data-name": "Ellipse 332",
    transform: "translate(794.645 210.092)",
    fill: "none",
    stroke: "#53b1ff",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.971,
    cy: 22.538,
    rx: 23.971,
    ry: 22.538,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.971,
    cy: 22.538,
    rx: 18.971,
    ry: 17.538,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2255);
export default __webpack_public_path__ + "static/media/Group2255.8c9af367ce673c4bad7df1284b76df9f.svg";
export { ForwardRef as ReactComponent };